export default "__VITE_ASSET__ba6562a3__"